import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import {useMediaQuery } from '@mui/material';
import "./CustomTab.scss";

interface TabProps {
  value: string;
  label: string;
}

interface CustomTabProps {
  tabs: TabProps[];
  value?: string;
  handleTabChange?: (event: React.SyntheticEvent, newValue: string) => void;
  hiddenTabs?: string[];
}

const CustomTab = ({
  tabs,
  value,
  handleTabChange,
  hiddenTabs = [],
}: CustomTabProps) => {

  const isMobile = useMediaQuery("(max-width: 900px)");

  return (
    <Box
      sx={{
        borderBottom: "1px solid #BCA685",
        marginLeft: isMobile ? "0px": "20px",
        marginRight: isMobile ? "0px": "20px",
        marginTop: "20px",
      }}
      className="customTabContainer"
    >
      <Tabs
        value={value}
        onChange={handleTabChange}
        textColor="primary"
        indicatorColor="primary"
        className="custom-tab"
        variant="scrollable"
      >
        {tabs.map((tab) =>
          !hiddenTabs.includes(tab.value) ? (
            <Tab
              sx={{
                fontSize: "16px",
                fontWeight: "400",
                padding: "5px",
                lineHeight: "18.75px",
                color: "#000000",
                textTransform: "none",
                marginRight: "1rem"
              }}
              key={tab.value}
              value={tab.value}
              label={tab.label}
            />
          ) : null
        )}
      </Tabs>
    </Box>
  );
};

export default CustomTab;
